export { PD6616_DIETARY_BADGES_FLAG } from './flag';
export { getDietaryBadges } from './dietaryBadges';
export type { DietaryBadgeId } from './dietaryBadges';
export { default as PD6616DietaryBadges } from './PD6616DietaryBadges';
export type { PD6616DietaryBadgesProps } from './PD6616DietaryBadges';
